import { getReturnedLoanRecords } from "../utils/loanUtils";
import {
  getDocumentData,
  getAuthors,
  hasOtherAuthors as getHasOtherAuthors,
  getTitle,
  getCallNumber,
  getCallNumberPrefix,
  getCallNumberSuffix,
  getBaseCallNumber,
  getBarcode,
} from "../utils/documentUtils";

export const useBookCardData = (
  formData,
  document,
  loanHistory,
  selectedItem = null
) => {
  const docData = getDocumentData(document, formData);
  const authors = getAuthors(docData);
  const hasOtherAuthors = getHasOtherAuthors(docData);
  const title = getTitle(docData, formData);

  // Get call number components
  const callNumberPrefix = getCallNumberPrefix(docData, formData);
  const baseCallNumber = getBaseCallNumber(docData, formData);
  const callNumberSuffix = getCallNumberSuffix(docData, formData, selectedItem);
  const callNumber = getCallNumber(docData, formData, selectedItem);
  const barcode = getBarcode(docData, formData, selectedItem);
  const loanRecords = getReturnedLoanRecords(loanHistory);

  return {
    docData,
    authors,
    hasOtherAuthors,
    title,
    callNumber,
    callNumberPrefix,
    baseCallNumber,
    callNumberSuffix,
    barcode,
    loanRecords,
    selectedItem,
  };
};
